import { useContext, useState } from 'react';

import AddImage from '../../reusable/images/add-image/add-image.component';
import Button from '../../reusable/button/button.component';
import ComponentModal from '../../reusable/component-modal/component-modal.component';
import AdminModal from '../../reusable/admin-modal/admin-modal.component';
import ProductImage from './product-image/product-image.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import Client from '../../../tools/client';
import { api } from '../../../config.js';

import {
    AddImageContainer,
    ImagesGrid
} from './product-images.styles';

const client = new Client();

const ProductImages = ({ product, getProduct }) => {
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState('');
    const [cropData, setCropData] = useState(null);
    const [images, setImages] = useState(product.ProductImages || []);
    const [showAddImage, setShowAddImage] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const { errorToast, successToast } = useContext(ToastContext);

    const addProductImage = async (overrideImage = image) => {
        if (!overrideImage) {
            errorToast('Please select an image.');
            return;
        }

        setLoading(true);

        let formData = new FormData();
        formData.append('files', overrideImage);
        formData.append('crop', JSON.stringify(cropData));
        formData.append('id', product.id);

        const res = await client.addProductImage(formData);

        if (res.status === 201) {
            await getProduct();
            successToast('Image added successfully');
        } else {
            errorToast('Failed to add product image');
        }

        setImage('');
        setLoading(false);
    };

    const confirmDelete = (image) => {
        setSelectedImage(image);
        setShowDeleteModal(true);
    };

    const handleDeleteImage = async () => {
        if (!selectedImage) return;

        setLoading(true);
        const res = await client.deleteProductImage({ id: selectedImage.id });

        if (res.status === 200) {
            await getProduct();
            successToast('Product image deleted');
        } else {
            errorToast('DELETE product image failed');
        }

        setShowDeleteModal(false);
        setSelectedImage(null);
        setLoading(false);
    };

    return (
        <>
            <AdminModal
                show={showDeleteModal}
                setShow={setShowDeleteModal}
                title={'Delete Product Image'}
                image={selectedImage ? api + selectedImage.path : ''}
                message={`Are you sure you want to delete this image?`}
                action={handleDeleteImage}
                actionText={'Delete'}
            />

            {loading ? 
                <Spinner />
            :
                <>
                    <AddImageContainer>
                        <ComponentModal
                            isOpen={showAddImage}
                            onClose={() => setShowAddImage(false)}
                            title="Add Product Image"
                        >
                            <AddImage
                                image={image}
                                setImage={setImage}
                                saveImage={addProductImage}
                                showSaveButton={true}
                                setCropData={setCropData}
                            />
                        </ComponentModal>
                        <Button onClick={() => setShowAddImage(true)}>Add New Image</Button>
                    </AddImageContainer>
                    <ImagesGrid>
                        {images.length > 0 && images.map((img, index) => (
                            <ProductImage
                                key={index}
                                image={img}
                                deleteImage={() => confirmDelete(img)}
                            />
                        ))}
                    </ImagesGrid>
                </>
            }
        </>
    );
};

export default ProductImages;